module.exports = __webpack_public_path__ + "static/media/laranja.c792bf29.png";